import {
  GET_ALL_INVESTMENT_LEADS,
  GET_ALL_INVESTMENT_LEADS_FAIL,
  GET_ALL_INVESTMENT_LEADS_SUCCESS,
  GET_INVESTMENT_LEAD_DETAILS,
  GET_INVESTMENT_LEAD_DETAILS_FAIL,
  GET_INVESTMENT_LEAD_DETAILS_SUCCESS,
  CREATE_INVESTMENT_LEAD,
  CREATE_INVESTMENT_LEAD_FAIL,
  CREATE_INVESTMENT_LEAD_SUCCESS,
  UPDATE_INVESTMENT_LEAD,
  UPDATE_INVESTMENT_LEAD_FAIL,
  UPDATE_INVESTMENT_LEAD_SUCCESS,
  DELETE_INVESTMENT_LEAD,
  DELETE_INVESTMENT_LEAD_SUCCESS,
  DELETE_INVESTMENT_LEAD_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  stateDetails: {},

  investmentLeads: {
    investment_lead: [],
    total: "",
    page: "",
  },
  investment_leadDetails: {},
  error: {},
  loading: false,
}

const InvestmentLead = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Client - This line cannot be edited or removed
    case GET_ALL_INVESTMENT_LEADS:
      return {
        ...state,
        loading: true,
        lastFetchParams: action.payload,
      }
    case GET_INVESTMENT_LEAD_DETAILS:
    case CREATE_INVESTMENT_LEAD:
    case UPDATE_INVESTMENT_LEAD:
    case DELETE_INVESTMENT_LEAD:
      return {
        ...state,
        loading: true,
      }

    case DELETE_INVESTMENT_LEAD_FAIL:
    case GET_ALL_INVESTMENT_LEADS_FAIL:
    case GET_INVESTMENT_LEAD_DETAILS_FAIL:
    case UPDATE_INVESTMENT_LEAD_FAIL:
    case CREATE_INVESTMENT_LEAD_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    case GET_ALL_INVESTMENT_LEADS_SUCCESS:
      return {
        ...state,
        investmentLeads: action.payload,
        error: {},
        loading: false,
      }

    case GET_INVESTMENT_LEAD_DETAILS_SUCCESS:
      return {
        ...state,
        clientDetails: action.payload,
        error: {},
        loading: false,
      }

    case CREATE_INVESTMENT_LEAD_SUCCESS:
      return {
        ...state,
        investmentLeads: {
          ...state.investmentLeads,
          investmentLeads: [
            action.payload,
            ...state.investmentLeads.investmentLeads,
          ],
          total: state.investmentLeads.total + 1,
        },
        investment_leadDetails: action.payload,
        error: {},
        loading: false,
      }

    case UPDATE_INVESTMENT_LEAD_SUCCESS:
      return {
        ...state,
        investmentLeads: {
          ...state?.investmentLeads,
          investmentLeads: state?.investmentLeads?.investmentLeads?.map(item =>
            item?._id === action?.payload?._id
              ? { ...item, ...action.payload }
              : item
          ),
        },
        investment_leadDetails: action.payload,
        loading: false,
        error: {},
      }

    case DELETE_INVESTMENT_LEAD_SUCCESS:
      return {
        ...state,
        investmentLeads: {
          ...state.investmentLeads,
          investmentLeads: state.investmentLeads.investmentLeads.filter(
            client => client._id !== action.payload._id
          ),
        },
        error: {},
        loading: false,
      }

    // State - This line cannot be edited or removed

    default:
      return state
  }
}

export default InvestmentLead
